import { useState, useCallback } from 'react';
import { FetchResponseI } from 'types';

interface Props<T, K> {
  getAll?: (filter?: K) => Promise<FetchResponseI<Array<T>>>;
  getOne?: (id: string, filter?: K) => Promise<FetchResponseI<T>>;
}

const useFetchData = <T, K>({ getAll, getOne }: Props<T, K>) => {
  const [allData, setAllData] = useState<Array<T>>([]);
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAll = useCallback(
    async (filter?: K) => {
      setLoading(true);
      const response: FetchResponseI<Array<T>> = await getAll(filter);
      setLoading(false);
      setAllData(response.data ?? []);
      setError(response.error);
    },
    [getAll]
  );

  const fetchOne = useCallback(
    async (id: string, filter?: K) => {
      setLoading(true);
      const response: FetchResponseI<T> = await getOne(id, filter);
      setLoading(false);
      setData(response.data ?? null);
      setError(response.error);
    },
    [getOne]
  );

  return {
    allData,
    data,
    loading,
    error,
    fetchAll,
    fetchOne,
  };
};

export default useFetchData;
